<template>
  <div id="n_-0_TOP__">

    <div v-show="this.isShowNewPlate" @click="tapPlateClose">
      <div class="new_get" v-show="this.is_new_plate === 1" ><img src="@/assets/img/seal/new_seal_get.png" alt="">
    <p><img src="@/assets/img/seal/close.png" alt=""></p>
    </div>
  </div>
    <div class="hed">
      <img src="@/assets/img/seal/sealCollectionHed.png" alt="" />
      <p class="tt_center">
        キャンペーン期間中にラリースタンプを{{ this.campaigns[0].goal_count }}枚集めると、<br />
        特別クーポンをゲット！
      </p>
      <TopMenu
        v-if="this.showTopMenu"
        :select="this.showItem"
        @click="tapCondition"
      />
    </div>
    <div class="seal" v-if="this.showItem === '開催中のキャンペーン' || this.showItem === undefined || this.showItem === '直近のキャンペーン'">
      <div class="title">{{ this.campaigns[0].name }}</div>
      <div class="no_campaigns" v-if="getExpiredAfter(this.campaigns[0].end_at) === false">キャンペーンは終了しました<br />次回開催までお待ちください</div>
      <div class="slider" v-bind:class="{ 'sliderTopPos': !getExpiredAfter(this.campaigns[0].end_at) }">
        <Plate3 :base="this.campaigns[0].template_url" :seals="this.campaigns[0].seals" :sealsList="this.campaigns[0].seals" v-if="this.campaigns[0].goal_count === 3"/>
        <Plate6 :base="this.campaigns[0].template_url" :seals="this.campaigns[0].seals" :sealsList="this.campaigns[0].seals" v-if="this.campaigns[0].goal_count === 6"/>
        <Plate9 :base="this.campaigns[0].template_url" :seals="this.campaigns[0].seals" :sealsList="this.campaigns[0].seals" v-if="this.campaigns[0].goal_count === 9"/>
      <div class="paging" v-if="this.campaigns[0].seals.length >= this.campaigns[0].goal_count">
        <div v-bind:class="{'cell1': this.page === 1, 'cell1active': this.page !== 1}" @click="tapBack()"> BACK</div>
        <div class="cell2">
              {{this.page}}</a> / {{getMaxPage()}}</a>
        </div>
        <div @click="tapNext()" v-bind:class="{'cell3': getMaxPage() === this.page, 'cell3active': getMaxPage() !== this.page}">NEXT </div>
      </div>
    <div class="coupon_text" v-if="this.campaigns[0].prize_history !== null && this.campaigns[0].prize_history.use_at === null"><img src="@/assets/img/seal/coupon_get.png" alt="" /></div>
    <div class="title" v-if="this.campaigns[0].prize_history !== null && this.campaigns[0].prize_history.use_at === null" @click="goCoupon">クーポンを見る</div>
    <div class="title_gray" v-if="this.campaigns[0].prize_history !== null && this.campaigns[0].prize_history.use_at !== null">クーポンは使用済みです</div>
    <div v-if="this.campaigns[0].prize_history !== null"></br></br></br></div>
    <div class="rule_title">
      ●香の川製麺スタンプラリーのルール
    </div>
    <div class="rule_desc"><div v-html="this.campaigns[0].detail"></div></div>
    </div>
    </div>
    <div
      class="prefecturesType"
      v-if="this.showItem === '都道府県別コレクション'"
    >
      <div class="prefectures_text">
        これまでに訪れた店舗の一覧です。<br />
        日付は、その店舗ではじめてラリースタンプを獲得した日です。
      </div>
      <div v-for="({order,prefecture,tenpo_count,seals,seal_empty}, index) in this.collection">
        <div class="prefectures">
          <p class="pp">{{ prefecture }}</p>
          <p class="cc">{{ seals.length }}店舗／{{ tenpo_count }}店舗</p>
        </div>
        <div class="sealBox">
          <div class="sealItem" v-if="seals.length === 0">
            <img :src="seal_empty.url" alt="" />
          </div>
          <div class="sealItem" v-for="seal in seals">
            <img :src="seal.url" alt="" />
            <p class="stroke" :class="{ is_android: isAndroid }">{{ seal.ryakusyo }}</p>
            <p class="t1" :class="{ is_android: isAndroid }" v-bind:style="{
            color: seal.text_color
          }">{{ seal.ryakusyo }}</p>
            <p class="t2" :class="{ is_android: isAndroid }">{{ getExpiredDate(seal.get_at) }}</p>
          </div>
         </div>
      </div>
    </br></br>
    </div>
    <!-- 過去のキャンペーン -->
    <div class="history" v-if="this.showItem === '過去のキャンペーン'">
      <div v-for="({detail,end_at,goal_count,id,name,prize_id,seals,start_at,template_url}, index) in this.campaigns_lists">
       <div class="item" @click="() => tapAction(id)">
        <div>
          <div class="item_title">{{ name }}</div>
          <div class="item_hiduke">
            実施期間：{{ setNenGappi(start_at) }}〜{{ setNenGappi(end_at) }}
          </div>
        </div>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'
import moment from 'moment'
import TopMenu from '@/components/SealTopMenu.vue'
import Plate3 from '@/components/SealPlate3.vue'
import Plate6 from '@/components/SealPlate6.vue'
import Plate9 from '@/components/SealPlate9.vue'
import { FactoryTrack, ContentsType } from '../constant/firebase'

export default {
  name: 'Seal',
  components: {
    TopMenu,
    Plate3,
    Plate6,
    Plate9
  },
  props: ['showItem'],
  data: function () {
    return {
      //showItem: '開催中のキャンペーン',
      showTopMenu: false,
      isExpiredCampaigns: false,
      page:1,
      isAndroid: false,
      isShowNewPlate:true,
      isKakoList: '0'

    }
  },
 async created() {
    document.title = '香の川製麺スタンプラリー'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = (payload) => {
        const json = JSON.parse(payload)
        this.fetchSealList(json.app_token, accTime, json.user_id)
        this.fetchSealCollection(json.app_token, accTime, json.user_id)
        this.fetchSealPrefectures(json.app_token, accTime, json.user_id)
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
      this.showTopMenu = true
      if(this.is_new_plate === 1){
        isShowNewPlate = true
      }
    } catch (e) {
      console.log(e)
    }
  },
  mounted: function () {
    document.title = '香の川製麺スタンプラリー'
    const ua = window.navigator.userAgent
    if (ua.indexOf('Android') >= 0) {
      this.isAndroid = true
    }
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 50)
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters({
      campaigns: 'Seal/campaigns',
      is_new_plate:'Seal/is_new_plate',
      collection: 'SealPrefectures/collection',
      selectedSealTab: 'SealTab/selectedSealTab',
      campaigns_lists: 'SealList/campaigns_lists'
    })
  },
  watch: {},
  methods: {
    ...mapActions('Seal', ['actionFetchSeals']),
    ...mapActions('SealList', ['actionFetchSealList','action_SelectDetailSeal']),
    ...mapActions('SealPrefectures', ['actionFetchSealPrefectures']),
    ...mapActions('Native', ['actionNavigateTo']),
    ...mapActions('Native', ['actionRequestToken']),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('SealTab', ['action_SetSelected']),
    ...mapActions('Analytics', ['trackEvent']),
    moment,
    async fetchSealCollection(token, accTime, userId) {
      try {
        this.actionToggleLoading(true)
        await this.actionFetchSeals({
          token,
          accTime,
          userId
        })
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)

    },
    getExpiredAfter(str) {
      const array = str.split('.')
      const dateAt = new Date(array[0])
      const today = new Date()
      if (dateAt.getTime() > today.getTime()){
        return true
      }
      else{
        return false
      }
    },
    setNenGappi(str) {
      const array = str.split('T')
      const date = array[0].split('-').join('/')
      return `${date}`
    },
    getExpiredDate(str) {
      const array = str.split('T')
      const date = array[0].split('-').join('.')
      return `${date}`
    },
    tapPlateClose(){
      this.isShowNewPlate = false
    },
    tapBack() {
      if(this.page >= 2){
        this.page = this.page - 1
        location.href='#slide-' + this.page
      }
      if(this.page >= 1){
        this.isBackPage = false
      }
      else{
        this.isBackPage = true
      }
      return false
    },
    getMaxPage() {
      return ((this.campaigns[0].seals.length / this.campaigns[0].goal_count) | 0) + 1
    },
    tapNext() {
      if(this.page < ((this.campaigns[0].seals.length / this.campaigns[0].goal_count) | 0) + 1 ){
        this.page = this.page  + 1
        location.href='#slide-' + this.page
        return false
      }
    },
    getSealsCount : async function () {
      return this.campaigns[0].seals.length
    },
    tapCondition(isSelect) {
      console.log('-- isSelect:' + isSelect)
      this.trackEvent(FactoryTrack.createSealCondition(isSelect))
      this.action_SetSelected(isSelect)
      this.showItem = isSelect
    },
    tapAction(id) {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createPreviousSeal(id, name))
      } catch (e) {
        console.log(e)
      }
      this.action_SelectDetailSeal(id)
      this.$router.push('/previousseal')
      //window.localStorage.setItem('seal-select', '過去のキャンペーン')
    },
    goSealFaq: async function () {
      this.trackEvent(FactoryTrack.createFAQSealCollection())
      this.$router.push('/faq/seal')
    },
    goCoupon: async function () {
      this.trackEvent(FactoryTrack.createTryCoupon())
      this.actionNavigateTo('2')
    },
    async fetchSealPrefectures(token, accTime, userId) {
      try {
        this.actionToggleLoading(true)
        await this.actionFetchSealPrefectures({
          token,
          accTime,
          userId
        })
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)
    },
    async fetchSealList(token, accTime, userId) {
      try {
        this.actionToggleLoading(true)
        await this.actionFetchSealList({
          token,
          accTime,
          userId
        })
      } catch (e) {
        this.errorMessage = e.message
        this.errorTitle = 'エラー' + e.code
        this.isError = true
        console.error(e)
      }
      this.actionToggleLoading(false)

    }
  }
}
</script>

<style lang="scss" scoped>
#n_-0_TOP__ {
  position: relative;
  width: 100%;
  height: auto;
  background-color: #FFFFFF;
  font-family: Hiragino Kaku Gothic ProN;
}
.hed {
  position: relative;
}

.hed img {
  width: 100%;
  height: auto;
  display: block;
}
.tt_center {
  position: absolute;
  width: 100%;
  top: 55.75%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Hiragino Kaku Gothic ProN;
  font-style: normal;
  font-weight: normal;
  font-size: 3.5vw;
  text-align: center;
  color: rgba(90, 34, 0, 1);
}
.seal {
  position: absolute;
  justify-content: center;
  display: flex;
  width: 100vw;
  background: #ffffff;
}
.title {
  width: 94vw;
  height: 13vw;
  background-color: #592205;
  border-radius: 5px 5px 5px 5px;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  position: absolute;
  font-size: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4vw;
}

.title_gray {
  width: 94vw;
  height: 13vw;
  background-color: #bbbbbb;
  border-radius: 5px 5px 5px 5px;
  color: #ffffff;
  font-weight: bold;
  text-align: center;
  position: absolute;
  font-size: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4vw;
}

.paging {
  position: relative;
  background-color: #f6f6f6;
  width: 100%;
  height: 11vw;
  display: block;
  padding-top:3vw;
  margin-bottom: 1vw;
}

.cell1active {
  position: absolute;
  font-size: 3.3vw;
  color: #5A2200 ;
  width: 20%;
  left: 0px;
}
.cell1active::before {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/left_icon.png');
}

.cell1 {
  position: absolute;
  font-size: 3.3vw;
  color: #BBBBBB ;
  width: 20%;
  left: 0vw;
}
.cell1::before {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/left_icon_off.png') ;
}

.cell2 {
  position: absolute;
  font-size: 3.3vw;
  left: 20vw;
  width: 60%;
}
.cell3active {
  position: absolute;
  font-size: 3.3vw;
  color: #5A2200;
  left: 78.5vw;
  width: 20%;
}
.cell3active::after {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/right_icon.png');

}
.cell3 {
  position: absolute;
  font-size: 3.3vw;
  color: #bbbbbb;
  left: 78.5vw;
  width: 20%;
}

.cell3::after {
  content: '';
  width: 2.2vw;
  height: 3.5vw;
  display: inline-block;
  background-size: cover;
  vertical-align: middle;
  background-image: url('~@/assets/img/seal/right_icon_off.png');
}


.new_get {
  position: relative;
  width: 100%;
  height: 12vw;
}
.new_get img {
  width: 100%;
  height: auto;
  display: block;
}
.new_get p{
	position: absolute;
	display: block;
	width:6vw;
	height:6vw;
	top:3vw;
	right:3vw;
}

.history {
  background: #ffffff;
  height:auto;
  padding-bottom:130vw;
}


.item {
  width: 100%;
  height: 18vw;
  display: flex;
  border-bottom: 1px solid #707070;
}

.item_title {
  width: 100%;
  color: #592205;
  font-weight: bold;
  position: absolute;
  font-size: 3.8vw;
  display: block;
  justify-content: left;
  align-items: left;
  margin-top: 4vw;
  margin-left: 3vw;
  text-align: left;
  clear: both;
}
.item_hiduke {
  color: #999999;
  font-weight: normal;
  position: absolute;
  font-size: 2.5vw;
  display: block;
  justify-content: left;
  align-items: left;
  margin-top: 10vw;
  margin-left: 3vw;
  text-align: left;
}

.item > div:after {
  content: '';
  display: inline-block;
  position: absolute;
  right: 15px;
  width: 1.8vw;
  height: 3.2vw;
  margin-top: 7vw;
  margin-right: 1vw;
  align-items: right;
  background-image: url('~@/assets/img/seal/next_mark.png');
  background-size: contain;
}

.prefectures_text {
  color: #222222;
  font-weight: normal;
  position: relative;
  font-size: 3vw;
  display: block;
  margin: 0 auto;
  padding-top: 4vw;
  width: 90vw;
  text-align: center;
}

.prefecturesType {
  background: #ffffff;
}

.prefectures {
  position: relative;
  height: 13vw;
  background-color: #592205;
  margin-top: 4vw;
  width: 92vw;
  margin: 0 auto;
  display: flex;
  margin-top: 4vw;
  justify-content: space-between;
}

.prefectures .pp {
  color: #ffffff;
  font-weight: bold;
  font-size: 4vw;
  left: 4vw;
  display: inline-block;
  margin-left: 4vw;
  margin-top: 3vw;
}

.prefectures .cc {
  color: #ffffff;
  font-weight: bold;
  font-size: 4vw;
  display: inline-block;
  margin-right: 4vw;
  margin-top: 3vw;
}
.sealBox {
  position: relative;
  width: 94vw;
  display: flex;
  flex-wrap: wrap;
  margin-left: 4vw;
  margin-bottom: 5vw;
}
.sealBox .sealItem {
  position: relative;
  width: 30vw;
  height: 27vw;
  padding: 0vw;
  margin-right: 1vw;
  margin-top: 5vw;
  margin-bottom:5vw;
}
.sealBox .sealItem img {
  width: 100%;
  height: auto;
  display: block;
}

.sealBox .sealItem .t1 {
  position: absolute;
  font-size: 2.9vw;
  font-weight: bold;
  width: 100%;
  top: 0.5vw;
  margin: 0;
}

.sealBox .sealItem .t1.is_android {
  top: 1.5vw;
  font-size: 3.1vw;
}

.sealBox .sealItem .stroke {
  position: absolute;
  color: red;
  font-size: 2.9vw;
  font-weight: bold;
  text-align: center;
  width: 100%;
  top: 0.5vw;
  margin: 0;
  -webkit-text-stroke: 3px white;
  text-stroke: 3px white;
}
.sealBox .sealItem .stroke.is_android {
  top: 1.5vw;
  font-size: 3.1vw;
}

.sealBox .sealItem .t2 {
  position: absolute;
  color: white;
  font-size: 2.1vw;
  text-align: center;
  width: 100%;
  top: 26.8vw;
}

.sealBox .sealItem .t2.is_android {
  top: 27.1vw;
}
.coupon_text {
  clear: both;
  display: block;
  width: 64vw;
  height: 4vw;
  margin: auto;
  margin-top: 5vw;
}
.coupon_text img {
  width: 100%;
  height: auto;
}

.rule_title {
  text-align: left;
  color: #5a2200;
  font-size: 16px;
  font-weight: bold;
  margin-top: 5vw
}

.prefecture_item{
  width: 94vw;
  position: relative;
  background: #ff0000;
}
.rule_desc {
  width: 90vw;
  color: #592205;
  font-weight: normal;
  position: relative;
  font-size: 3.5vw;
  display: block;
  margin-top: 2vw;
  line-height: 1.7;
  justify-content: left;
  align-items: left;
  text-align: left;
  clear: both;
}
.seal_faq {
  display: block;
  width: 71vw;
  height: 4vw;
  margin: auto;
  margin-top: 5vw;
  left: 15vw;
  padding-bottom: 10vw;
}

.seal_faq img {
  width: 100%;
  height: auto;
  display: block;
}
.slider {
  width: 94vw;
  height: auto;
  text-align: center;
  overflow: hidden;
}

.sliderTopPos{
  margin-top:22vw;
  display:inline-block;
}
.nextActive {
  color: #5A2200;
}

.no_campaigns {
  width: 94vw;
  border-radius: 5px 5px 5px 5px;
  color: #e03535;
  font-weight: bold;
  text-align: center;
  position: absolute;
  font-size: 5.5vw;
  display: block;
  justify-content: center;
  align-items: center;
  margin-top: 21vw;
}
</style>
